export default __webpack_public_path__ + "static/media/ngc.d4792160.svg";